"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Flattens a given graph.
 */
class FlatteningGraphTransformer {
    /** @inheritDoc */
    transform(graph, processor, options) {
        let result = graph;
        if (graph.find(_ => _["@graph"])) {
            result = [].concat.apply([], graph[0]["@graph"].map(item => (item["@id"] && item["@graph"] ? item["@graph"] : [item])));
        }
        return result;
    }
}
exports.default = FlatteningGraphTransformer;
//# sourceMappingURL=FlatteningGraphTransformer.js.map